(() => {
  const aliases = {
    year: 'Year', 年份: 'Year', size: 'Size', dimensions: 'Size', 尺寸: 'Size',
    color: 'Color', colour: 'Color', 颜色: 'Color', hardware: 'Hardware', 五金: 'Hardware',
    condition: 'Condition', 成色: 'Condition', material: 'Material', 材质: 'Material',
    accessories: 'Accessories', 'included accessories': 'Accessories', 配件: 'Accessories'
  };
  const normalize = (text) => text.trim().replace(/[.。]$/, '').replace(/\s+/g, ' ').toLowerCase();
  class ProductInformation extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced) return;
      const original = this.querySelector('[data-description]');
      if (!original) return;
      const copy = original.cloneNode(true);
      const fields = [];
      const seen = new Set();
      const title = normalize(this.dataset.title || '');
      const candidates = [...copy.querySelectorAll('p,li,tr,h2,h3,h4')];
      if (!candidates.length && !copy.children.length) {
        for (const line of copy.textContent.split(/\n/).filter(line => line.trim())) {
          const p = document.createElement('p');
          p.textContent = line;
          candidates.push(p);
        }
        copy.replaceChildren(...candidates);
      }
      for (const node of candidates) {
        if (!copy.contains(node) || node.querySelector('p,li,tr,h2,h3,h4,img,video,a,iframe,table,br')) continue;
        let text = node.textContent.trim();
        if (node.tagName === 'TR') {
          const cells = [...node.children];
          if (cells.length !== 2) continue;
          text = `${cells[0].textContent.replace(/[:：]\s*$/, '')}: ${cells[1].textContent}`;
        }
        if (title && normalize(text) === title) { node.remove(); continue; }
        const match = text.match(/^([^:：]+)[:：]\s*([\s\S]*)$/);
        const key = match && aliases[match[1].trim().toLowerCase()];
        if (!key) continue;
        const value = match[2].trim().replace(/\.$/, '');
        if (value) {
          const signature = `${key}:${normalize(value)}`;
          if (!seen.has(signature)) { fields.push([key, value]); seen.add(signature); }
        }
        node.remove();
      }
      for (const node of [...copy.querySelectorAll('ul,ol,tbody,thead,table,p,div')].reverse()) {
        if (!node.textContent.trim() && !node.querySelector('img,video,iframe,hr')) node.remove();
      }
      const list = document.createElement('dl');
      list.className = 'product-facts';
      for (const [key, value] of fields) {
        const label = document.createElement('dt');
        const detail = document.createElement('dd');
        label.textContent = `${key}:`;
        detail.textContent = value;
        list.append(label, detail);
      }
      const contents = [];
      if (fields.length) contents.push(list);
      if (copy.textContent.trim() || copy.querySelector('img,video,iframe,hr')) contents.push(copy);
      this.replaceChildren(...contents);
      this.hidden = !contents.length;
      this.dataset.enhanced = 'true';
    }
  }
  if (!customElements.get('upup-product-information')) customElements.define('upup-product-information', ProductInformation);
})();
